exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nmain[data-v-5ebff0fc] {\n  padding: 40px 0;\n}\n.title[data-v-5ebff0fc] {\n  font-size: 24px;\n  font-weight: bold;\n}\n.withdrawal-msg[data-v-5ebff0fc] {\n  width: 50%;\n  border: 1px solid #9e9e9e;\n  margin: auto;\n  padding: 24px;\n  text-align: left;\n}\n.section1[data-v-5ebff0fc] {\n  margin-bottom: 24px;\n}\n.section2[data-v-5ebff0fc] {\n  margin-bottom: 24px;\n}\n.section2 p[data-v-5ebff0fc] {\n    font-weight: bold;\n}\n.section3[data-v-5ebff0fc] {\n  margin-bottom: 24px;\n}\n.section3 p[data-v-5ebff0fc] {\n    font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ebff0fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Recruit/Withdrawal.vue
// module id = jEfZ
// module chunks = 0